import React from 'react';
import { injectIntl } from 'react-intl';
import { messages } from '@smovilgps/optimus-intl';
import { Col, Input, Pagination, Row, Spin } from 'antd';
import PropTypes from 'prop-types';
const Search = Input.Search;

class MobileCommonTable extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			search: '',
			current: 1,
		};
	}

	MySearch = (value) => {
		const { search } = this.props;
		value = value.trim();
		this.setState({ search: value });
		search(value);
	};

	pagingOnChange = (page, pageSize) => {
		const { search } = this.props;
		search(this.state.search, page, pageSize);
		this.setState({ current: page });
	};

	render() {
		const list = this.props.dataSource.map(this.props.card);
		return (
			<div className="MobileTable">
				<Row className="control" type="flex" justify="space-between" align="middle">
					<Col
						className="action control"
						xs={{ span: 12 }}
						sm={{ span: 4 }}
						md={{ span: 4 }}
						lg={{ span: 2 }}
					>
						{this.props.Add}
					</Col>
					<Col
						xs={{ span: 24, offset: 0 }}
						sm={{ span: 8, offset: 8 }}
						md={{ span: 8, offset: 12 }}
						lg={{ span: 8, offset: 12 }}
					>
						<Search
							placeholder={this.props.intl.formatMessage(messages.searchPlaceholder)}
							onSearch={(value) => this.MySearch(value)}
						/>
					</Col>
				</Row>
				<Spin spinning={this.props.loading}>{list}</Spin>
				<Row className="control" type="flex" justify="space-around" align="middle">
					<Col>
						<Pagination
							defaultPageSize={10}
							current={this.state.current}
							onChange={this.pagingOnChange}
							total={this.props.recordCount}
						/>
					</Col>
				</Row>
			</div>
		);
	}
}

MobileCommonTable.propTypes = {
	dataSource: PropTypes.array.isRequired,
	loading: PropTypes.bool.isRequired,
	intl: PropTypes.object.isRequired,
	Add: PropTypes.object.isRequired,
	search: PropTypes.func.isRequired,
	recordCount: PropTypes.number.isRequired,
	card: PropTypes.func.isRequired,
};

export default injectIntl(MobileCommonTable);
